<template>
  <div>

    <router-link
      :to="{name: 'acc-cash-list'}"
      class="text-decoration-none text-white"
    >
      <b-button
        class="mb-1"
        variant="primary"
      >
        <feather-icon
          icon="ArrowLeftIcon"
          class="mr-75"
        />
        Kembali
      </b-button>
    </router-link>
    <b-card>
      <!-- required required Wajib diisi -->
      <!-- min:x min:3 Minimal x karakter -->
      <!-- max:x max:10 Maksimal x karakter -->
      <!-- email email Format email valid -->
      <!-- numeric numeric Hanya angka -->
      <!-- between:x,y between:1,10 Antara nilai x dan y -->
      <!-- confirmed confirmed:password Cocok dengan field lain -->
      <validation-observer ref="simpleRules">
        <b-form>
          <b-row>
            <!-- Nama Kategori -->
            <b-col cols="12">
              <b-form-group
                label="Kode COA"
                label-for="category"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Kode COA"
                  rules="required"
                >
                  <b-form-input
                    id="coa"
                    v-model="coa"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Kode COA"
                    @keypress="onlyNumberAndDot"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>

            <b-col cols="12">
              <b-form-group
                label="Nama COA"
                label-for="category"
                label-cols-md="4"
              >
                <validation-provider
                  #default="{ errors }"
                  name="Nama COA"
                  rules="required"
                >
                  <b-form-input
                    id="name"
                    v-model="name"
                    :state="errors.length > 0 ? false:null"
                    placeholder="Masukkan Nama COA"
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider></b-form-group>
            </b-col>
            <!-- Tombol Aksi -->
            <b-col
              md="8"
              offset-md="4"
            >
              <b-button
                type="submit"
                variant="success"
                class="mr-1"
                @click.prevent="validationForm"
              >
                Simpan
              </b-button>
              <b-button
                type="reset"
                variant="outline-secondary"
              >
                Reset
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer></b-card>

  </div>
</template>

<script>
import {
  BFormInput, BFormGroup, BRow, BCol, BButton, BCard, BForm,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
// eslint-disable-next-line import/no-cycle
import Ripple from 'vue-ripple-directive'
import { required } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BFormInput,
    BFormGroup,
    BRow,
    BForm,
    BCol,
    BButton,
    BCard,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      name: null,
      coa: null,
      required,
    }
  },
  computed: {},
  created() {
  },
  mounted() {
  },
  methods: {
    submitData() {
      const payload = {
        coa: this.coa,
        name: this.name,
      }

      console.log(payload)

      this.$http.post('/coa/add', payload)
        .then(() => {
          this.$bvToast.toast('COA berhasil ditambahkan!', {
            title: 'Sukses',
            variant: 'success',
            solid: true,
          })
          // Reset redirect
          this.$router.push({ name: 'acc-coa-list' })
        })
        .catch(err => {
          let message = 'Gagal menambahkan COA.'

          if (err.response) {
            // Cek jika ada response dari server
            if (err.response.status === 422 && err.response.data.errors) {
              // Menangani error validasi (422 Unprocessable Entity)
              const { errors } = err.response.data
              // Gabungkan semua pesan error menjadi satu string
              message = Object.values(errors).flat().join(' ')
            } else if (err.response.data && err.response.data.message) {
              // Menangani error lainnya dengan pesan dari Laravel
              message = err.response.data.message
            }
          }

          this.$bvToast.toast(message, {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })

          console.error(err)
        })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.submitData()
        } else {
          this.$bvToast.toast('Lengkapi Data Sebelum Submit!', {
            title: 'Error',
            variant: 'danger',
            solid: true,
          })
        }
      })
    },
    onlyNumberAndDot(e) {
      const char = String.fromCharCode(e.keyCode || e.which)
      if (!/[0-9.]/.test(char)) {
        e.preventDefault()
      }
    },
  },
}
</script>
